export default __webpack_public_path__ + "static/Garrett_logo-63c9b93908254f6226a034e7fc36efa1.png";